import React from 'react'
import { ChargingCardsTableDesktopView } from './ChargingCardsTableDesktopView'
import { ChargingCardModel } from '../api/models/charging-card-model'
import { useMediaQuery, useTheme } from '@mui/material'
import { ChargingCardsTableMobileView } from './ChargingCardsTableMobileView'

interface ChargingCardsTableProps {
  chargingCards: ChargingCardModel[]
  installationId: number
  installationHasWallboxes: boolean
}

/** Component shows charging cards data in table view */
export const ChargingCardsTable: React.FC<ChargingCardsTableProps> = ({ chargingCards, installationId, installationHasWallboxes }) => {
  const theme = useTheme()
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'))

  return isMobileOrTablet ? (
    <ChargingCardsTableMobileView chargingCards={chargingCards} installationId={installationId} installationHasWallboxes={installationHasWallboxes} />
  ) : (
    <ChargingCardsTableDesktopView
      chargingCards={chargingCards}
      installationId={installationId}
      installationHasWallboxes={installationHasWallboxes}
    />
  )
}
